export const apiPath = "/v1/certificates";
const actionType = "ASSETS"

export const bulkActionType = `${actionType}_BULK`;

export default actionType
